(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-pdp-videos-slider"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".pdp-videos-wrapper-slider", {
    slidesPerView: 5,
    spaceBetween: 15,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: ".right-arrow",
      prevEl: ".left-arrow",
    },
    breakpoints: {
      1200: { slidesPerView: 5 },
      992: { slidesPerView: 4 },
      768: { slidesPerView: 3 },
      576: { slidesPerView: 2 },
      0: { slidesPerView: 1.2 },
    },
  });
  
let autoplayInterval = null;
let userPlayingVideo = false;

function playActiveSlideVideo() {
  const slider = document.querySelector(".pdp-videos-wrapper-slider");
  if (!slider) return;

  // Pause all videos first
  slider.querySelectorAll(".pdp-video video").forEach(function (vid) {
    vid.pause();
    vid.currentTime = 0;
    vid.closest(".pdp-video-item").classList.remove("playing");
    const playBtn = vid.closest(".pdp-video-item").querySelector(".pdp-play-btn");
    if (playBtn) playBtn.style.opacity = 1;
  });

  // Get active slide’s video
  const activeSlide = slider.querySelector(".swiper-slide-active");
  const video = activeSlide ? activeSlide.querySelector("video") : null;

  if (video && !userPlayingVideo) {
    video.muted = true; // autoplayed videos stay muted
    video.play();
    activeSlide.classList.add("playing");
  }
}

function startAutoPlay() {
  if (autoplayInterval) clearInterval(autoplayInterval);
  playActiveSlideVideo();

  autoplayInterval = setInterval(function () {
    swiper.slideNext();
    setTimeout(playActiveSlideVideo, 300);
  }, 9000);
}

function stopAutoPlay() {
  if (autoplayInterval) {
    clearInterval(autoplayInterval);
    autoplayInterval = null;
  }
}

function pauseAllVideos() {
  document.querySelectorAll(".pdp-video video").forEach(function (vid) {
    vid.pause();
    vid.currentTime = 0;
    vid.closest(".pdp-video-item").classList.remove("playing");
    const btn = vid.closest(".pdp-video-item").querySelector(".pdp-play-btn");
    if (btn) btn.style.opacity = 1;
  });
}

// Function to play a specific video (unmuted for user interaction)
function playVideo(video, btn) {
  stopAutoPlay();
  userPlayingVideo = true;
  pauseAllVideos();

  const reviewActionBtn = video.closest(".pdp-video-item").querySelector(".video-play-action");
  if (reviewActionBtn) {
    reviewActionBtn.style.opacity = 0.7;
    reviewActionBtn.style.display = "block";
  }

  if (btn) btn.style.opacity = 0;
  btn.style.display= "none";
  video.muted = false;
  video.play();
  video.closest(".pdp-video-item").classList.add("playing");

  video.addEventListener("ended", function handleVideoEnd() {
    if (btn) btn.style.opacity = 1;
    btn.style.display= "flex";
    if (reviewActionBtn) {
      reviewActionBtn.style.opacity = 0;
      reviewActionBtn.style.display = "none";
    }
    video.closest(".pdp-video-item").classList.remove("playing");
    userPlayingVideo = false;
    startAutoPlay();
    video.removeEventListener("ended", handleVideoEnd);
  });
}


document.querySelectorAll(".pdp-play-btn").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    e.stopPropagation(); // prevent triggering video-item click
    const video = this.closest(".pdp-video-item").querySelector("video");
    const reviewActionBtn = this.closest(".pdp-video-item").querySelector(".video-play-action");
    if (reviewActionBtn) reviewActionBtn.style.opacity = 0.7;
    if (reviewActionBtn) reviewActionBtn.style.display = "block";
    if (video) playVideo(video, this);
  });
});


document.querySelectorAll(".pdp-video-item").forEach(function (item) {
  item.addEventListener("click", function (e) {
    const video = this.querySelector("video");
    const btn = this.querySelector(".pdp-play-btn");
    if (!video) return;

    // If currently playing → pause
    if (this.classList.contains("playing")) {
      video.pause();
      this.classList.remove("playing");
      if (btn) btn.style.opacity = 1;
      btn.style.display= "flex";
      const reviewActionBtn = this.querySelector(".video-play-action");
      if (reviewActionBtn) {
        reviewActionBtn.style.opacity = 0;
        reviewActionBtn.style.display = "none";
      }
      userPlayingVideo = false;
      startAutoPlay();
    } else {
      const reviewActionBtn = this.closest(".pdp-video-item").querySelector(".video-play-action");
      if (reviewActionBtn) reviewActionBtn.style.opacity = 0.7;
      if (reviewActionBtn) reviewActionBtn.style.display = "block";
      playVideo(video, btn);
    }
  });
});


swiper.on("slideChangeTransitionEnd", function () {
  if (!userPlayingVideo) playActiveSlideVideo();
});

window.addEventListener("load", startAutoPlay);

  } catch(e) { console.error(e); }
})();
})();
